<template>
    <div
        ref="barRef"
        :class="$style.bar"
    >
        <div
            ref="progressRef"
            :class="$style.progress"
        />
    </div>
</template>
<script lang="ts" setup>
import { ref, watch } from 'vue'

import { useAppStore } from '@/store/app-store'

const appStore = useAppStore()

const barRef = ref<HTMLDivElement>()
const progressRef = ref<HTMLDivElement>()

watch(
    () => appStore.pageLoadProgress,
    (isActive) => {
        const barElem = barRef.value
        const progressElem = progressRef.value
        if (!progressElem || !barElem) {
            return
        }

        if (isActive) {
            progressElem.style.opacity = '1'

            // Start asymptotic animation to 70%
            progressElem.animate([{ width: '0%' }, { width: '70%' }], {
                duration: 5000,
                easing: 'cubic-bezier(0.2, 0, 0.05, 1)', // Asymptotic curve: fast start, very slow approach
                fill: 'forwards',
            })
        } else {
            progressElem
                .animate([{ width: '100%' }], {
                    duration: 500,
                    easing: 'ease-out',
                    fill: 'forwards',
                })
                .addEventListener('finish', () => {
                    progressElem.style.opacity = '0'
                })
        }
    },
)
</script>
<style module>
.bar {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
}

.progress {
    height: 1px;
    opacity: 0;
    background-color: var(--purple-300);
}
</style>
